import { queryOptions } from '@tanstack/react-query';
import { deleteBookmark, getBookmarks, postBookmark, putBookmark } from '@/actions/bookmarks';
import type { Bookmark, CreateBookmark } from '@/types/bookmarks';
import type { User } from '@/types/user';

const RESOURCE = 'bookmarks' as const;

const bookmarks = {
  byUserId: ({ userId }: { userId: User['id'] }) =>
    queryOptions({
      queryFn: () => getBookmarks({ userId }),
      queryKey: [RESOURCE, 'byUserId', userId] as const,
    }),
  createBookmark: () => ({
    mutationFn: (data: CreateBookmark) => postBookmark({ data }),
    mutationKey: [RESOURCE, 'post'] as const,
  }),
  updateBookmark: ({ bookmarkId }: { bookmarkId: Bookmark['id'] }) => ({
    mutationFn: (data: Bookmark) => putBookmark({ bookmarkId, data }),
    mutationKey: [RESOURCE, 'put', bookmarkId] as const,
  }),
  deleteBookmark: ({ bookmarkId }: { bookmarkId: Bookmark['id'] }) => ({
    mutationFn: () => deleteBookmark({ bookmarkId }),
    mutationKey: [RESOURCE, 'delete', bookmarkId] as const,
  }),
};

export { bookmarks, RESOURCE as BOOKMARKS_QUERY_KEY };
